/* global $ */

$('.expandable-section .toggle').click(function(e) {
  e.preventDefault();
  console.log('click');
  const $this = $(this);
  const $accordion = $this.parent().parent();
  const $inner = $accordion.find('.inner');

  if ($inner.hasClass('visible')) {
    $inner.removeClass('visible');
    $this.removeClass('animate');
    $inner.slideUp(350);
  } else {
    $accordion
      .parent()
      .find('.inner')
      .removeClass('visible');
    $accordion
      .parent()
      .find('.inner')
      .slideUp(350);
    $accordion
      .parent()
      .find('.toggle')
      .removeClass('animate');
    $this.toggleClass('animate');
    $inner.toggleClass('visible');
    $inner.slideToggle(350);
  }
});
